import anime from "animejs";
import { useAtomValue } from "jotai";
import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { modalState } from "@stores/modal";
import Confetti from "@components/elements/Confetti";
import playSound from "@/sound";
import { clickSound } from "@stores/vars";

const Wrap = styled.div`
  position: fixed;
  width: 100%;
  height: calc(100% - 0px);
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 500;
`;

const AlertBox = styled.div`
  margin-left: 410px;
  position: relative;
  width: 919px;
  height: 518px;
  background: url(${require("@assets/img/confirm_bg.png")}) no-repeat;
  &.complete {
    &:after {
      content: "";
      position: absolute;
      left: 235px;
      top: -80px;
      width: 506px;
      height: 177px;
      background: url(${require("@assets/img/confirm_work_complete.png")})
        no-repeat;
      background-size: 100% 100%;
    }
    .text-inner {
      height: 250px;
      margin-top: 75px;
    }
    .m-btn-wrap {
      button {
        transition: all 0.2s !important;
        &:active {
          transform: scale(0.95);
          transform-origin: center center;
        }
        &.yes {
          background: url(${require("@assets/img/confirm_ok.png")}) no-repeat;
          background-size: 100% 100%;
          margin-left: 10px;
        }
        &.no {
          background: url(${require("@assets/img/confirm_re.png")}) no-repeat;
          background-size: 100% 100%;
          margin-right: 10px;
        }
      }
    }
  }
  &.alert {
    .m-btn-wrap {
      button {
        transition: all 0.2s !important;
        &:active {
          transform: scale(0.95);
          transform-origin: center center;
        }
        &.yes {
          background: url(${require("@assets/img/confirm_ok2.png")}) no-repeat;
          background-size: 100% 100%;
          margin-left: 10px;
        }
        &.no {
          display: none;
        }
      }
    }
  }
`;

const TextInner = styled.div`
  width: 980px;
  height: 270px;
  text-align: center;
  margin-top: 45px;
  display: flex;
  flex-direction: column;
  color: #fff;
  font-size: 65px;
  align-items: center;
  justify-content: center;
  line-height: 1.3;
  text-shadow: 3px 3px 0px rgba(0, 0, 0, 0.2);
`;

const CharImg = styled.div`
  position: absolute;
  left: -410px;
  top: 77px;
  img {
    width: 400px;
  }
`;

const ButtonWrap = styled.div`
  position: absolute;
  width: 970px;
  bottom: 80px;
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    transition: all 0.2s !important;
    &:active {
      transform: scale(0.95);
      transform-origin: center center;
    }
    width: 309px;
    height: 115px;
    &.yes {
      background: url(${require("@assets/img/confirm_ok.png")}) no-repeat;
      background-size: 100% 100%;
      margin-left: 10px;
    }
    &.no {
      background: url(${require("@assets/img/confirm_no.png")}) no-repeat;
      background-size: 100% 100%;
      margin-right: 10px;
    }
  }
`;

const char_m = [
  require("@data/assets/_static/welcome_m1.png"),
  require("@data/assets/_static/welcome_m2.png"),
  require("@data/assets/_static/welcome_m3.png"),
  require("@data/assets/_static/welcome_m4.png"),
];
const char_w = [
  require("@data/assets/_static/welcome_w1.png"),
  require("@data/assets/_static/welcome_w2.png"),
  require("@data/assets/_static/welcome_w3.png"),
];

const ModalComplete = () => {
  const welcomeImg =
    window.__welcomeRandom[0] === true
      ? char_m[window.__welcomeRandom[1]]
      : char_w[window.__welcomeRandom[1]];

  const alertRef = useRef(null);
  const a = useAtomValue(modalState);

  const onNo = () => {
    a.closeCallback(false);
  };

  const onYes = () => {
    a.closeCallback(true);
  };

  useEffect(() => {
    if (alertRef.current) {
      //clickSound
      if (a.type === "confirm" || a.type === "alert")
        playSound.effect(clickSound);
      anime({
        targets: alertRef.current,
        opacity: [0, 1],
        scale: [0.6, 1],
        easing: "easeOutBack",
        duration: 500,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alertRef.current]);
  return (
    <Wrap>
      <AlertBox
        ref={alertRef}
        className={a.type === "complete" ? "complete" : a.type}
      >
        <CharImg>
          <img src={welcomeImg} alt="" />
        </CharImg>
        <TextInner
          className="text-inner"
          dangerouslySetInnerHTML={{ __html: a.msg }}
        />
        <ButtonWrap className="m-btn-wrap">
          <button type="button" className="no" onClick={onNo} />
          <button type="button" className="yes" onClick={onYes} />
        </ButtonWrap>
      </AlertBox>
      {a.type === "complete" && <Confetti isStart={true} />}
    </Wrap>
  );
};

export default ModalComplete;
